var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 268,
    viewBox: "0 0 268 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 268,
    height: 268,
    rx: 134,
    fill: "white",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.8403 73.0775L117.95 111.467C119.5 114.167 117.5 117.507 114.31 117.507H70.0903C66.9003 117.507 64.9003 114.167 66.4503 111.467L88.5603 73.0775C90.1503 70.3075 94.2503 70.3075 95.8503 73.0775H95.8403Z",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2002 99.3075V89.1975",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7299 108.407C94.7299 109.805 93.5972 110.937 92.1999 110.937C90.8026 110.937 89.6699 109.805 89.6699 108.407C89.6699 107.01 90.8026 105.877 92.1999 105.877C93.5972 105.877 94.7299 107.01 94.7299 108.407Z",
    fill: "#39BBD3",
    stroke: "#39BBD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.66 140.74L169.75 131.65C167.66 127.26 166.49 122.35 166.49 117.16C166.49 98.5 181.61 83.38 200.27 83.38C206.31 83.38 211.97 84.96 216.87 87.74L196.78 107.83L209.62 120.67L229.71 100.57C232.49 105.47 234.07 111.13 234.07 117.17C234.07 135.84 218.94 150.96 200.28 150.96C195.1 150.96 190.18 149.79 185.79 147.7L176.7 156.79",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.691 214.8L106.211 227.28C101.771 231.72 94.5908 231.72 90.1608 227.28C87.9508 225.07 86.8408 222.16 86.8408 219.26C86.8408 216.36 87.9508 213.45 90.1608 211.24L102.651 198.75",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.91 184C149.92 188.01 149.92 194.5 145.91 198.5C141.9 202.5 135.41 202.51 131.41 198.5L109.69 176.78C105.68 172.77 105.68 166.28 109.69 162.28C113.7 158.28 120.19 158.27 124.19 162.28L145.91 184Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.19 162.28C120.18 158.27 120.18 151.78 124.19 147.78C128.2 143.77 134.69 143.77 138.69 147.78L151.21 160.3",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.96 151.04C137.95 147.03 137.95 140.54 141.96 136.54C145.97 132.53 152.46 132.53 156.46 136.54L174.13 154.21",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.048 201.347C156.368 194.667 156.368 183.847 163.048 177.177L158.218 182.007C154.208 186.017 147.718 186.017 143.718 182.007L138.888 177.177C137.548 175.837 137.548 173.677 138.888 172.347L158.228 153.008C162.238 148.997 168.728 148.997 172.728 153.008L177.558 157.838C193.578 173.858 193.578 199.837 177.558 215.857C161.538 231.877 135.557 231.877 119.537 215.857L102.008 198.327C97.9975 194.317 97.9975 187.827 102.008 183.827C106.018 179.817 112.507 179.817 116.507 183.827L127.68 195C131.69 199.01 131.69 205.5 127.68 209.5C123.67 213.5 117.18 213.51 113.18 209.5",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.49 136.39H66.06C58.85 136.39 53 130.54 53 123.33V112.79",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.391 112.79V123.33C131.391 130.54 125.551 136.39 118.331 136.39H106.891",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0107 83.38V71.06C53.0107 63.85 58.8507 58 66.0707 58H77.5007",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106.9 58H118.34C125.55 58 131.4 63.85 131.4 71.06V83.38",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponse);
export default __webpack_public_path__ + "static/media/response.48d32a964e589af59a39f231d8f93bf7.svg";
export { ForwardRef as ReactComponent };